<template>
  <div class="app-container" v-loading="listLoading">
    <el-row style="padding-top: 10px; padding-left: 10px;">
      <el-col class="order-data">
        <div style="padding-left: 20px;">
          <p><b>{{ generateCustomizeString('orderDetail') }}</b></p>
        </div>
        <div style="padding-left: 20px; padding-top: 20px">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('orderId') }}: </span>
              <span class="content-label">{{ orderDetailData.out_trade_no }}</span>
            </div>
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('orderCreateAt') }}: </span>
              <span class="content-label">{{ orderDetailData.created_at | toLocalTime }}</span>
            </div>
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('username') }}: </span>
              <span class="content-label" v-if="orderDetailData.customer_name">{{ orderDetailData.customer_name }}</span>
              <span class="content-label" v-if="wechatDetail.nickname">{{ wechatDetail.nickname }}</span>
            </div>
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('status') }}: </span>
              <span class="content-label">{{ orderDetailData.status_name }}</span>
            </div>
            <!-- <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('remark') }}: </span>
              <span class="content-label">{{ orderDetailData.message }}</span>
            </div> -->
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('consignee') }}: </span>
              <span class="content-label">{{ orderAddress.consignee_name }}</span>
            </div>
            <div class="grid-content">
              <span class="title-label">收件人电话: </span>
              <span class="content-label">{{ orderAddress.phone }}</span>
            </div>
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('totalFee') }}: </span>
              <span class="content-label">{{ orderDetailData.fee }}</span><br>
              <span style="padding-left: 100px;">(含运费{{ orderDetailData.express_fee }})</span>
            </div>
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('profit') }}: </span>
              <span class="content-label">{{ orderDetailData.profit }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="grid-content">
              <span class="title-label">{{ generateCustomizeString('shippingInfo') }}: </span>
              <span class="content-label">
                <el-button size="small" @click="viewShippingInfo(orderExpressData)">{{ generateCustomizeString('viewShippingInfo') }}</el-button>
              </span>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col class="order-data" style="margin-top: 20px; padding: 10px;" v-if="orderDetailData.order_cost_fee_detail">
        <div style="padding-left: 10px;">
          <p><b>订单金额详情</b></p>
        </div>
        <div style="padding: 0 10px;">
          <el-table :data="orderActivityData" tooltip-effect="dark" border style="width: 50%">
            <el-table-column align="center" :label="generateCustomizeString('orderActivity')">
              <template slot-scope="scope">
                <div v-if="scope.row.use_activity_list && scope.row.use_activity_list.length > 0">
                  <div v-for="item in scope.row.use_activity_list" :key="item.id">
                    <div>{{ item.title }}</div>
                  </div>
                </div>
                <div v-else>{{ generateCustomizeString('none') }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 10px 0px 10px;">
          <el-table :data="orderFeeDetail" tooltip-effect="dark" border style="width: 100%">
            <el-table-column align="center" prop="total_goods_fee" :label="generateCustomizeString('originalGoodsFee')"></el-table-column>
            <el-table-column align="center" prop="goods_fee" :label="generateCustomizeString('discountedGoodsFee')">
              <template slot-scope="scope">
                <div>{{ scope.row.total_goods_fee }}</div>
                <div v-if="scope.row.use_activity_list && scope.row.use_activity_list.length > 0">
                  - {{ scope.row.total_activity_reduction + ' (' + generateCustomizeString('promotionActivity') + ')' }}
                </div>
                <!-- <div v-if="scope.row.use_coupon_list && scope.row.use_coupon_list.length > 0">
                  - {{ scope.row.total_coupon_reduction + ' (' + generateCustomizeString('couponActivity') + ')' }}
                </div> -->
                <div v-if="scope.row.use_activity_list.length > 0">
                  = {{ scope.row.total_goods_fee_after_discounted }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="total_express_fee" :label="generateCustomizeString('originalShippingFee')"></el-table-column>
            <el-table-column align="center" prop="express_fee" :label="generateCustomizeString('discountedShippingFee')">
              <template slot-scope="scope">
                <div>{{ scope.row.total_express_fee }}</div>
                <div v-if="parseInt(scope.row.total_express_fee_reduction) !== 0">
                  - NZD ${{ scope.row.total_express_fee_reduction + ' (' + generateCustomizeString('promotionActivity') + ')' }}
                </div>
                <div v-if="parseInt(scope.row.total_express_fee_reduction) !== 0">= {{ scope.row.total_express_fee_after_discounted }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="fee" :label="generateCustomizeString('orderShopPrice')">
              <template slot-scope="scope">
                <div>{{ scope.row.total_goods_fee_after_discounted }} + {{ scope.row.total_express_fee_after_discounted }}</div>
                <div>= {{ scope.row.total_fee_after_discounted }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 10px;">
          <el-table :data="orderFeeDetail" tooltip-effect="dark" border style="width: 70%">
            <el-table-column align="center" prop="total_fee_after_discounted" :label="generateCustomizeString('orderShopPrice')">
            </el-table-column>
            <el-table-column align="center" prop="profit" :label="generateCustomizeString('agentProfit')"></el-table-column>
            <el-table-column align="center" prop="fee" :label="generateCustomizeString('orderFinalPrice')">
              <template slot-scope="scope">
                <div>{{ scope.row.total_fee_after_discounted }} + {{ scope.row.profit }}</div>
                <div>= {{ scope.row.fee }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col class="order-data" style="margin-top: 20px; padding: 10px;">
        <div style="padding-left: 10px;">
          <p><b>订单商品</b></p>
        </div>
        <el-table
          :data="orderProductData"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row>
          <!-- <el-table-column label="SKU" prop="sku">
          </el-table-column> -->
          <el-table-column label="产品" width="300">
            <template slot-scope="scope">
              <img :src="scope.row.productThumbnailUrl" style="width: 50px;"><br>
              <span>{{ scope.row.productTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="unitPrice">
          </el-table-column>
          <el-table-column label="数量" prop="quantity">
          </el-table-column>
          <el-table-column label="合计" prop="total">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col class="order-data" style="margin-top: 20px;">
        <div style="padding-left: 20px;">
          <p><b>{{ generateCustomizeString('orderPhoto') }}</b></p>
        </div>
        <div v-for="(item, index) in imageList" :key="index" style="padding-top: 20px; padding-left: 20px;">
          <img :src="item + '?imageView2/0/w/350/h/350/q/75|imageslim'" @click="viewAttachmentClick(item)" style="width: 200px;">
        </div>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="shippingInfoDialogVisible" title="物流信息" style="margin-bottom: 10px;">
      <el-collapse accordion v-for="(express, index) in orderExpressData" :key="index" @change="expressTraceClick(express)">
        <el-collapse-item :title="express.expressCompany + ' ' + express.expressNumber" v-loading="express.infoLoading">
          <div v-if="expressInfoData.length !== 0">
            <el-steps direction="vertical" :active="0" v-loading="expressInfoLoading" v-for="(trace, index) in expressInfoData" :key="index">
              <el-step :title="trace.expressTime" icon="el-icon-location-outline" :description="trace.expressContext"></el-step>
            </el-steps>
          </div>
          <div v-else>暂无物流信息</div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>

    <el-dialog title="查看订单附加图片" :visible.sync="viewAttachmentVisible" width="80%">
      <div>
        <img :src="viewAttachment" style="width: 100%;">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'OrderDetails',
  data() {
    return {
      listLoading: false,
      isMobile: false,
      shippingInfoDialogVisible: false,
      expressInfoLoading: false,
      orderDetailData: {},
      orderProductData: [],
      expressInfoData: [],
      wechatDetail: [],
      orderAddress: [],
      orderExpressData: [],
      imageList: [],
      imgListKey: [],
      infoLoading: false,
      viewAttachmentVisible: false,
      viewAttachment: '',
      orderFeeDetail: [],
      orderActivityData: []
    }
  },
  created() {
    this.fetchOrderInfo()
    // this.checkMobile()
  },
  methods: {
    generateCustomizeString,
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    viewShippingInfo() {
      this.shippingInfoDialogVisible = true
    },
    viewAttachmentClick(item) {
      this.viewAttachment = ''
      this.viewAttachmentVisible = true
      this.viewAttachment = item + '?imageView2/0/w/800/h/800/q/75|imageslim'
    },
    expressTraceClick(data) {
      this.expressInfoLoading = true
      data.infoLoading = true
      this.expressInfoData = []
      request({
        url: '/express/trace/detail',
        method: 'get',
        params: {
          express_number: data.expressNumber,
          express_company_id: data.expressCompanyId
        }
      })
        .then(response => {
          const expressInfo = []
          if (response.data.trades.length > 0) {
            for (var i = 0; i < response.data.trades.length; i++) {
              var obj = {}
              obj.expressTime = response.data.trades[i].time
              obj.expressContext = response.data.trades[i].context

              expressInfo[i] = obj
            }
          }
          this.expressInfoData = expressInfo.reverse()

          this.expressInfoLoading = false
          data.infoLoading = false
        })
        .catch(error => {
          console.warn(error)
          this.expressInfoLoading = false
          data.infoLoading = false
        })
    },
    fetchOrderInfo() {
      if (this.listLoading) return
      this.listLoading = true

      request({
        url: 'order/' + this.$route.params.orderId,
        method: 'get'
      })
        .then(response => {
          const orderAddressData = response.data.order_address
          this.orderDetailData = response.data
          this.orderAddress = orderAddressData

          var orderFeeDetailData = {}
          if (response.data.order_cost_fee_detail) {
            orderFeeDetailData = response.data.order_cost_fee_detail
          }
          var orderActivity = {}
          if (response.data.order_cost_fee_detail) {
            orderActivity = response.data.order_cost_fee_detail.detail_json
          }

          if (response.data.customer.wechat_auths.length && response.data.customer.wechat_auths[0].user_info) {
            this.wechatDetail = response.data.customer.wechat_auths[0].user_info
          }

          // Order fee details
          const orderFeeDetailDataTmp = {}
          if (orderFeeDetailData) {
            orderFeeDetailDataTmp.total_goods_fee =
              'NZD $' + parseFloat((orderFeeDetailData.total_goods_fee * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_activity_reduction =
              'NZD $' + parseFloat((orderFeeDetailData.total_activity_reduction * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_goods_fee_after_discounted =
              'NZD $' + parseFloat((orderFeeDetailData.total_goods_fee_after_discounted * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_express_fee =
              'NZD $' + parseFloat((orderFeeDetailData.total_express_fee * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_express_fee_after_discounted =
              'NZD $' + parseFloat((orderFeeDetailData.total_express_fee_after_discounted * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_express_fee_reduction =
              parseFloat(((orderFeeDetailData.total_express_fee - orderFeeDetailData.total_express_fee_after_discounted) * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_coupon_reduction =
              'NZD $' + parseFloat((orderFeeDetailData.total_coupon_reduction * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.total_fee_after_discounted =
              'NZD $' + parseFloat((orderFeeDetailData.total_fee_after_discounted * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.profit = 'NZD $' + parseFloat((response.data.profit * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.fee = 'NZD $' + parseFloat((response.data.fee * 100) / 10000).toFixed(2)
            orderFeeDetailDataTmp.use_activity_list = []
            orderFeeDetailDataTmp.use_coupon_list = []
            if (orderFeeDetailData.detail_json) {
              orderFeeDetailDataTmp.use_activity_list = orderFeeDetailData.detail_json.use_activity_list
              orderFeeDetailDataTmp.use_coupon_list = orderFeeDetailData.detail_json.use_coupon_list
            }
          }
          this.orderFeeDetail.push(orderFeeDetailDataTmp)
          this.orderActivityData.push(orderActivity)
          console.log(this.orderFeeDetail)

          // OrderFees
          this.orderDetailData.express_fee = this.formatPrice(response.data.express_fee)
          this.orderDetailData.fee = this.formatPrice(response.data.fee)
          this.orderDetailData.profit = response.data.profit !== 0 ? this.formatPrice(response.data.profit) : ''

          // Expresses
          const orderExpresses = []
          if (response.data.expresses.length > 0) {
            for (var e = 0; e < response.data.expresses.length; e++) {
              var eobj = {}
              if (response.data.expresses[e].express_company && response.data.expresses[e].express_company_id > 0) {
                eobj.expressCompanyId = response.data.expresses[e].express_company_id
                eobj.expressCompany = response.data.expresses[e].express_company.name
                eobj.queryUrl = response.data.expresses[e].express_company.order_query_url
              } else {
                eobj.expressCompanyId = null
                eobj.expressCompany = ''
                eobj.queryUrl = ''
              }
              eobj.expressNumber = response.data.expresses[e].express_number
              eobj.infoLoading = false

              orderExpresses[e] = eobj
            }
          }
          this.orderExpressData = orderExpresses
          console.log(this.orderExpressData)

          // Product Data
          const order_goods = response.data.order_goods
          const data = order_goods

          for (let i = 0; i < order_goods.length; i++) {
            var obj = {}
            if (order_goods[i].first_image_url) {
              obj.productThumbnailUrl =
                order_goods[i].first_image_url +
                '?imageView2/0/w/128/h/128/q/75|imageslim'
            }
            obj.productTitle = order_goods[i].product_full_name
            obj.productId = order_goods[i].bar_code
            if (order_goods[i].best_use_before_at !== null) {
              obj.bestBefore = order_goods[i].best_use_before_at
            } else {
              obj.bestBefore = '最新'
            }
            obj.unitPrice = 'NZD $' + parseFloat(order_goods[i].order_price / 100).toFixed(2)
            obj.quantity = order_goods[i].quantity
            obj.total =
              'NZD $' +
              parseFloat(order_goods[i].order_price * order_goods[i].quantity / 100).toFixed(2)

            data[i] = obj
          }
          this.orderProductData = data
          console.log(this.orderProductData)

          // images
          this.imageList = []
          this.imgListKey = []
          console.log(this.imageList)
          const images = response.data.images
          for (let i = 0; i < images.length; i++) {
            this.imageList.push(images[i].image_url)
            this.imgListKey.push(images[i].qiniu_res_key)
          }

          this.listLoading = false
          console.log(this.imageList)
        })
        .catch(error => {
          console.warn(error)
          this.listLoading = false
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-data {
  padding: 20px 0;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
.grid-content {
  min-height: 50px;
  margin: 0 auto;
  flex: auto;
  overflow: auto;
  -webkit-align-items: center;
  align-items: center;
}
.title-label {
  display: inline-block;
  text-align: right;
  width: 90px;
}
.content-label {
  padding: 0px 0px 0px 10px;
}
</style>
<style type="text/css">
  .el-dialog {
    width: 60%;
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: 90%;
    }
  }
</style>
